"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputStyle = void 0;

var _styledComponents = require("styled-components");

var InputBaseStyle = (0, _styledComponents.css)(["--inputFontSize:26px;--inputLineHeight:31px;--placeholderColor:var(--colors-lynch);--inputColor:var(--colors-blank);--inputBorderSize:2px;--inputBorderColor:rgba(255,255,255,0.3);--inputBackground:var(--brandPrimary);--topLabelColor:rgba(255,255,255,0.5);--labelTextColor:rgba(255,255,255,0.5);background-color:transparent;opacity:1;border-radius:0;border-width:0;border-bottom:var(--inputBorderSize) solid var(--inputBorderColor);", ";", ""], function (_ref) {
  var theme = _ref.theme;
  var style;

  if (theme.size === 'small') {
    style = (0, _styledComponents.css)(["--inputFontSize:20px;--inputLineHeight:24px;"]);
  }

  if (theme.size === 'extra-small') {
    style = (0, _styledComponents.css)(["--inputFontSize:16px;--inputLineHeight:19px;"]);
  }

  return style;
}, function (_ref2) {
  var theme = _ref2.theme;
  var style;

  if (theme.mode === 'light') {
    style = (0, _styledComponents.css)(["--placeholderColor:var(--colors-blank);--inputColor:var(--colors-blank);--inputBorderColor:", ";--inputBackground:var(--brandPrimary);--inputBackgroundActive:", ";&:hover,&:focus{--inputBorderColor:var(--colors-blank);}"], theme.colors.blank_30, theme.colors.chambray_45);
  }

  if (theme.mode === 'dark') {
    style = (0, _styledComponents.css)(["--placeholderColor:var(--colors-bayoux);--inputColor:var(--colors-darkBlue);--inputBorderColor:var(--colors-geyser);--inputBackground:var(--colors-blank);--inputBackgroundActive:", ";&:hover,&:focus{--inputBorderColor:var(--brandPrimary);}"], theme.colors.irisBlue_15);
  }

  return style;
});
/**
 * Since we're using this input style with our own Input component and with third party
 * components, we need to set some css variables and change accordingly.
 *
 * This style will implement some default values but other components might override these variables
 * if they need to implement a theme around it.
 * The default will be the styles for the onboarding theme, either colors, fontSize or backgrounds.
 */

var InputStyle = (0, _styledComponents.css)(["", " font-size:var(--inputFontSize);line-height:var(--inputLineHeight);color:var(--inputColor);border-color:var(--inputBorderColor);font-weight:normal;display:block;width:100%;padding-bottom:10px;margin-bottom:8px;transition:0.2s border-color;&.error{--inputBorderColor:var(--colors-redPink);}&:hover,&:focus{outline:0;}&::-webkit-input-placeholder{color:var(--placeholderColor);}&:-ms-input-placeholder{color:var(--placeholderColor);}&::placeholder{color:var(--placeholderColor);opacity:1;}&[data-com-onepassword-filled='dark'],&[data-com-onepassword-filled='light'],&:-webkit-autofill,&:-webkit-autofill:hover,&:-webkit-autofill:focus{", " -webkit-text-fill-color:var(--inputColor) !important;background-clip:text;-webkit-background-clip:text;}&:read-only,&:disabled{color:var(--colors-lynch);cursor:not-allowed;&,&:hover{--inputBorderColor:var(--colors-pigeon);}}"], InputBaseStyle, InputBaseStyle);
exports.InputStyle = InputStyle;